import isEqual from 'lodash/isEqual'
import sortBy from 'lodash/sortBy'
import { toJS } from 'mobx'

/**
 * @title 判断form表单的值是否修改改：true：改变；false：未改。value为提交值
 */
export const isChange = (
  new_tag_ids,
  case_detail,
  set_meal_detail,
  isChanged
) => {
  let flag = isChanged
  // 对比案例属性
  console.log(case_detail)
  const tagIds = case_detail.tags.map(item => item.markId)
  if (JSON.stringify(sortBy(new_tag_ids)) != JSON.stringify(sortBy(tagIds))) {
    flag = true
  }
  // 有变化

  const meal_detail = case_detail.setMealDetail
  // 对比案例详情信息
  if (!isChangeCaseDetail(toJS(meal_detail), toJS(set_meal_detail))) {
    flag = true
  }

  return flag
}

/**
 * @title 对比案例详情信息前后是否有改动
 */

export const isChangeCaseDetail = (prevCase, currentCase) => {
  return isEqual(prevCase, currentCase)
}
